import React, { useRef } from 'react'
import { Box, TextField } from '@mui/material'

const OtpInput = ({ value = '', onChange, disabled = false, error = false }) => {
  const inputRefs = useRef([])
  const digits = value.split('').concat(Array(6 - value.length).fill(''))

  const handleChange = (index, e) => {
    const val = e.target.value
    if (val && !/^\d$/.test(val)) return

    const newDigits = [...digits]
    newDigits[index] = val
    const newValue = newDigits.join('')
    onChange(newValue)

    if (val && index < 5) {
      inputRefs.current[index + 1]?.focus()
    }
  }

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !digits[index] && index > 0) {
      inputRefs.current[index - 1]?.focus()
    }
  }

  const handlePaste = (e) => {
    e.preventDefault()
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6)
    if (pasted.length > 0) {
      onChange(pasted)
      const focusIndex = Math.min(pasted.length, 5)
      inputRefs.current[focusIndex]?.focus()
    }
  }

  return (
    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
      {digits.slice(0, 6).map((digit, index) => (
        <TextField
          key={index}
          inputRef={(el) => inputRefs.current[index] = el}
          value={digit}
          onChange={(e) => handleChange(index, e)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          onPaste={index === 0 ? handlePaste : undefined}
          disabled={disabled}
          error={error}
          inputProps={{
            maxLength: 1,
            style: { textAlign: 'center', fontSize: '24px', fontWeight: 'bold' },
            inputMode: 'numeric',
          }}
          sx={{ width: 52 }}
          size="medium"
          autoFocus={index === 0}
        />
      ))}
    </Box>
  )
}

export default OtpInput
